var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.currentPosition)?_c('GmapMarker',{attrs:{"position":_vm.currentPosition,"clickable":false,"draggable":false,"icon":_vm.icon}}):_vm._e(),(_vm.currentPosition)?_c('GmapCircle',{attrs:{"center":_vm.currentPosition,"clickable":false,"draggable":false,"radius":_vm.currentPositionAccuracy,"visible":true,"options":{
      fillColor: 'blue',
      fillOpacity: 0.2,
      strokeWeight: 0,
      cursor: 'default',
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }